<template>
  <div class="start__trial_wrapper">
    <VCard class="pa-5 start__trial">
      <VRow class="align-stretch">
      <svg
        class="start__trial_icon"
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.2331 12.775L12.4998 2.14168C11.9331 1.32501 10.9915 0.833344 9.9998 0.833344C9.00813 0.833344 8.06646 1.31668 7.4748 2.16668L0.774796 12.7583C-0.0752044 13.975 -0.233538 15.4333 0.358129 16.5583C0.941462 17.6833 2.16646 18.325 3.6998 18.325H16.2998C17.8415 18.325 19.0581 17.6833 19.6415 16.5583C20.2248 15.4333 20.0665 13.9833 19.2331 12.775ZM9.16646 5.83334C9.16646 5.37501 9.54146 5.00001 9.9998 5.00001C10.4581 5.00001 10.8331 5.37501 10.8331 5.83334V10.8333C10.8331 11.2917 10.4581 11.6667 9.9998 11.6667C9.54146 11.6667 9.16646 11.2917 9.16646 10.8333V5.83334ZM9.9998 15.8333C9.30813 15.8333 8.7498 15.275 8.7498 14.5833C8.7498 13.8917 9.30813 13.3333 9.9998 13.3333C10.6915 13.3333 11.2498 13.8917 11.2498 14.5833C11.2498 15.275 10.6915 15.8333 9.9998 15.8333Z" fill="#F94141" />
      </svg>
      <VCol cols="12" lg="8" class="pa-0">
        <VList class="d-flex justify-space-between flex-column pa-0">
          <VListItem class="mb-2">
            <div v-if="isExpired">
              {{ $t('isExpiredTrialTitle') }}
            </div>
            <slot v-else name="title">
              <div>
                {{ $t('trialTitle') }}
              </div>
            </slot>
          </VListItem>
          <VListItem>
            <div v-if="isExpired">
              {{ $t('isExpiredTrialText') }}
            </div>
            <slot v-else name="subtitle">
              <div>
                {{ $t('trialText.trialText1') }}
                <br>
                <span v-if="account && account.trialAvailable && !isExpired">{{ $t('trialText.trialText2') }}</span>
              </div>
            </slot>
          </VListItem>
        </VList>
      </VCol>

      <VCol cols="12" lg="4" class="start__trial_links pa-0">
        <div
          v-if="account && account.trialAvailable && !isExpired"
          class="pa-0 text-end try-days-block"
          cols="12"
          lg="2"
        >
          <RouterLink
            class="button-trial"
            :to="{ name: 'settings',
                   params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } }"
          >
            {{ $t('free') }}
          </RouterLink>
        </div>
        <div
          class="pa-0 text-center change-tariff-block"
          cols="12"
          lg="2"
        >
          <RouterLink
            class="button-tariff"
            :to="isExpired ? { name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.INFO } } : { name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } }"
          >
            <span v-if="isExpired">{{ $t('payTheTariff') }}</span>
            <span v-else>{{ $t('changeTariff') }}</span>
          </RouterLink>
        </div>
      </VCol>
    </VRow>
    </VCard>
  </div>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import useSubscription from '@/compositions/accounting/useSubscription';
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'FeatureAlertCard',
  setup() {
    const { account } = useAccount();
    const { isExpired } = useSubscription();

    return {
      account,
      isExpired,
      paymentTabs,
      settingsTabs,
    };
  },
};
</script>

<style scoped lang="scss">
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
  border-radius: 10px;
}
.v-card::v-deep {
  background-color: #F5F5F5;
  border-radius: 10px;
}
.v-list::v-deep {
  background-color: #F5F5F5;
}
.v-list-item__subtitle {
  flex: auto;
  overflow: inherit;
}
.start {
  &__trial_wrapper {
    position: relative;
  }
  &__trial {
    background-color: #FFECEC !important;
    padding-left: 68px !important;
    position: relative;
    overflow: visible;
    @media screen and (max-width: 600px) {
      padding: 20px 40px !important;
    }
    &_icon {
      position: absolute;
      top: 20px;
      left: 20px;
      @media screen and (max-width: 600px) {
        position: static;
        margin-bottom: 15px;
      }
    }
    &_links {
      display: flex;
      align-items: center;
      @media screen and (max-width: 1265px) {
        margin-top: 10px;
      }
      @media screen and (max-width: 600px) {
        justify-content: space-between;
        margin-top: 20px;
      }
    }
    .row {
      display: flex;
      align-items: center !important;
      .try-days-block {
        margin-right: 25px;
      }
      .change-tariff-block {
        white-space: nowrap;
      }
    }
    .v-list {
      background-color: #FFECEC;
      > div:nth-child(1) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #212121 !important;
      }
      > div:nth-child(2) {
        font-weight: 300;
        font-size: 16px;
        line-height: 150%;
        color: #666666 !important;
      }
      .v-list-item {
        min-height: auto;
        padding: 0;
      }
    }

    .button-trial {
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      color: #0A82D9;
    }

    .button-tariff {
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      color: #212121;
    }
  }
}

</style>

<i18n lang="yml" locale="en">
  trialTitle: 'The career portal is available with the «Standard» tariff and above.'
  trialText: {
    trialText1: "Learn about the system’s functionality and create your own portal.",
    trialText2: "Get to know all of Huntica’s features by activating a free 30-day trial period."
  }
  free: 30 days for free
  changeTariff: Change your tariff
  payTheTariff: Pay the tariff

  isExpiredTrialTitle: Your tariff is inactive.
  isExpiredTrialText: To gain access to all the functions of your tariff, you need to make a payment.
</i18n>

<i18n lang="yml" locale="ru">
  trialTitle: 'Карьерный портал доступен на тарифе «Стандарт» и выше.'
  trialText: {
    trialText1: 'Изучите функционал и создайте свой портал.',
    trialText2: 'Познакомьтесь со всеми возможностями Huntica, активируя пробный период на 30 дней бесплатно.'
  }
  free: Бесплатно 30 дн.
  changeTariff: Сменить тариф
  payTheTariff: Оплатить тариф

  isExpiredTrialTitle: Тариф закончился
  isExpiredTrialText: Для получения доступа к функциям Вашего тарифа необходимо внести оплату.
</i18n>
